export const routes = {
  index: "/",
  dashboard: "/dashboard",
  userList: "/user",
  taskTitle: "/task-title",
  leadType: "/lead-type",
  task: "/task",
  lead: "/lead",
  appointment: "/appointment",
  parcel: "/parcel",
  making: "/making",
  CustomerAttend: "/customer-attend",
  helpNeeded: "/help",
  additionalWork: "/additional-work",
  improvement: "/improvement",
  dcHanging: "/dc-hanging",
  dbBackup: "/db-backup",
  taskReport: "/task-report",
  fabric: "/requirement",
  rentmakinglist: "/un-bill",
  rentmakingcreate: "/un-bill/create",
  rentmakingupdate: "/un-bill/update",
  categories: "/categories",
  occasion: "/occasion",
  whatsAppMessage: "/whatsApp-message",
  sendMessgae: "/sop",
  unBillReport: "/un-bill-report",
  customerAttendReport: "/customer-attend-report",
  vendors: "/vendors",
  purchaseBill: "/purchase-bill",
  handWork: "/hand-work",
  otherCost: "/other-cost",
  workers: "/worker",
  stitchingWorkers: "/stitching-workers",
  stitchingMasters: "/stitching-masters",
  handWorkOrder: "/hand-work-order",
  designerOrder: "/designer-order",
  stitchingOrder: "/stitching-order",
  workerHoliday: "/worker-holiday",
  setting: "/setting",
  leave: "/employee-leave",
  employeeSalary: "/employee-salary",
  attendanceLog: "/attendance-log",
  advanceLog: "/advance-log",
  attendanceReport: "/attendance-report",
  attendanceUser: "/attendance-user",
  dailyAttendanceReport: "/daily-report",
  rackshelf: "/rack-shelf",
  khaKhaRack: "/kha-kha-rack",
  materialRack: "/material-rack",
  drawRequirement: "/draw-requirement",
  cuttingRequirement: "/cutting-requirement",
}